// extracted by mini-css-extract-plugin
export default {"container":"Suppliers_container__qBCKg","data-grid":"Suppliers_data-grid__s5VTm"};